import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import store from "./store";
import "./assets/fonts/icons.js";
import "./Services/GlobalVariables";

import "bootstrap/dist/js/bootstrap.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/icons.js";
import "./Services/GlobalVariables";
import "@/plugins/export-excel";
import "@/plugins/export-pdf";
import DrawerLayout from "vue-drawer-layout";
import Loading from "vue-loading-overlay";
import { startBatchTimer } from "@/composables/useAppUsage";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "./registerServiceWorker";
import { App as CapacitorApp } from "@capacitor/app";

let options = {
  sensitivity: 100, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ["NumLock", "Clear"], // default is null
  callbackAfterTimeout: true, // default is false
};


Vue.component("v-select", vSelect);
Vue.component("loading", Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false;

Vue.component("loading", Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false;

/**
 * Android hardware back button handling via Capacitor.
 * Behavior:
 * - If there is navigation history (native or SPA), go back within the router.
 * - If on a designated root route, require a second back press within 1200ms to exit the app.
 * - Otherwise, attempt a router.back() fallback.
 *
 * Adjust ROOT_ROUTES if you change your top-level routes.
 */
const ROOT_ROUTES = ["Login", "dashboard"]; // route names
let __backPressTs = 0;

if (CapacitorApp && CapacitorApp.addListener) {
  try {
    CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      const canRouterGoBack = typeof window !== "undefined" && window.history && window.history.length > 1;

      if (canGoBack || canRouterGoBack) {
        if (router && typeof router.back === "function") router.back();
        else if (typeof window !== "undefined") window.history.back();
        return;
      }

      const current = router && router.currentRoute ? router.currentRoute : null;
      const isRoot = current && current.name ? ROOT_ROUTES.includes(current.name) : false;

      if (!isRoot) {
        if (router && typeof router.back === "function") router.back();
        else if (typeof window !== "undefined") window.history.back();
        return;
      }

      const now = Date.now();
      if (now - __backPressTs < 1200) {
        CapacitorApp.exitApp();
      } else {
        __backPressTs = now;
        // TODO: replace with your toast/snackbar component
        console.log("Press back again to exit");
      }
    });
  } catch (e) {
    // Non-fatal: continue without custom back handling
    console.warn("Capacitor backButton handler failed to init", e);
  }
}

// document.addEventListener(
//   "contextmenu",
//   function (e) {
//     e.preventDefault();
//   },
//   false
// );
new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
  mounted() {
    // Start App Usage batch timer (auto-flush every 30 seconds)
    startBatchTimer()
  },
}).$mount("#app");
